import isArray from './isArray';
import isObject from './isObject';
import isString from './isString';

export default function $(x) {
  return isArray(x) ? '[' + x.map($) + ']'
    : isObject(x) || isString(x) ?
      // Output valid JSON and JS source strings.
      // See http://timelessrepo.com/json-isnt-a-javascript-subset
      JSON.stringify(x).replace('\u2028','\\u2028').replace('\u2029', '\\u2029')
    : x;
}



// WEBPACK FOOTER //
// ./~/vega-util/src/stringValue.js